// extracted by mini-css-extract-plugin
export var container = "_14-0";
export var disabled = "_14-4";
export var fullWidth = "_14-3";
export var lined = "_14-1";
export var selected = "_14-5";
export var tab = "_14-2";